import { NgModule } from '@angular/core';
import { ManpowerService } from './manpower.service';
import { ManpowerBackend } from './manpower.backend';

@NgModule({
  providers: [ManpowerService, ManpowerBackend],
})
export class ManpowerModule {}
